import { IonButton, IonFooter, IonToolbar } from '@ionic/react'
import styled from 'styled-components'

export type FooterButtonType = {
  color: string
  text: string
  link?: string
  onClick?: () => void
  disabled?: boolean
}

type Props = {
  button: FooterButtonType
  rightButton?: FooterButtonType
}

export const FooterButtons: React.FC<Props> = ({ button, rightButton }) => {
  return (
    <IonFooter>
      <StyleToolbar color={'transparent'}>
        <ButtonsWrapper>
          <ButtonWrapper>
            <StyleButton
              onClick={button.onClick}
              color={button.color}
              expand={'block'}
              routerLink={button.link}
              disabled={button.disabled}
            >
              {button.text}
            </StyleButton>
          </ButtonWrapper>
          {rightButton != null && (
            <ButtonWrapper>
              <StyleButton
                onClick={rightButton.onClick}
                color={rightButton.color}
                expand={'block'}
                routerLink={rightButton.link}
                disabled={rightButton.disabled}
              >
                {rightButton.text}
              </StyleButton>
            </ButtonWrapper>
          )}
        </ButtonsWrapper>
      </StyleToolbar>
    </IonFooter>
  )
}

const StyleToolbar = styled(IonToolbar)`
  --min-height: 85px;
  background-color: var(--ion-color-white);
`

const ButtonsWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 0% 5% 0% 5%;
  gap: 2%;
  display: flex;
  justify-content: center;
  align-items: center;
`

const ButtonWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`

const StyleButton = styled(IonButton)`
  width: 100%;
  height: 55px;
  font-size: 16px;
  font-weight: 700;
  --border-radius: 8px;
`
